import { FeatureTypes } from "entity-app/constants";

export type TMilestonesTemplate = {
  sequence_no: number;
  name: string;
  id: string;
  milestone_action: string;
  next_offset: Array<{
    name: string;
    id: string;
    duration: number;
  }>;
};

export enum ComputeStrategy {
  DURATION_DRIVEN = "duration_driven",
  COMMITTED_DATE_DRIVEN = "committed_date_based"
}

export type TWorkflowTemplate = {
  name: string;
  id: string;
  feature_id: number;
  feature: {
    show_float: boolean;
  };
  float: number;
  dateblock_compute_strategy: {
    key: ComputeStrategy;
    name?: string;
    description?: string;
  };
};

export type TProjectWorkflowTemplate = TWorkflowTemplate & {
  project_template_milestones: Array<TMilestonesTemplate>;
};

export type TSubscriptionWorkflowTemplate = TWorkflowTemplate & {
  subscription_template_milestones: Array<TMilestonesTemplate>;
};

export type TEditMilestone = {
  id: string;
  milestone_action: string;
  name: string;
  offsetName: string | null;
  duration: number | null;
  sequence_no?: number;
};

export type TSaveWorkflowModelInput = {
  template_id: string;
  name: string;
  feature: FeatureTypes;
  milestones: {
    name: string;
    milestone_action: string;
    sequence: number;
  }[];
  offsets: {
    duration: number;
    name: string;
    prev_milestone: string;
    next_milestone: string | null;
  }[];
  float: number;
};
